import axios from 'axios';
/**
 * Клиент API для эндпоинта GET /rest/api/v1/categories/{categoryId}/articles.
 * Эндпоинт публичный — аутентификация не требуется.
 */
export class CategoryArticlesApi {
    async getArticles(categoryId, params = {}) {
        const { page = 1, size } = params;
        const queryParams = {
            page: String(page),
        };
        if (size != null) {
            queryParams.size = String(size);
        }
        const response = await axios.get(`/rest/api/v1/categories/${categoryId}/articles`, { params: queryParams });
        return response.data;
    }
}
